import React from 'react'

import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { useGoTo } from '@web/hooks/useGoTo'
import useMe from '@web/hooks/useMe'
import links from '@web/libs/constants/links'
import routes from '@web/libs/constants/routes'
import nClicks from '@web/libs/nlog/click/codes'

import Clickable from '../Clickable'
import styles from './Footer.module.scss'

const Footer: React.FC = () => {
  const { login } = useMe()
  const { isFromMapsApp } = useGlobalStaticStateContext()
  const { goToLogin, goToLogout, goTo } = useGoTo()

  const goToPolicy = () => {
    goTo(routes.POLICY_MY_PLACE, { openWindow: isFromMapsApp })
  }
  return (
    <footer className={styles.footer}>
      <div className={styles.main_btn_area}>
        <span className={styles.btn_wrapper}>
          {login ? (
            <Clickable onClick={() => goToLogout()} className={styles.btn}>
              로그아웃
            </Clickable>
          ) : (
            <Clickable onClick={() => goToLogin()} className={styles.btn}>
              로그인
            </Clickable>
          )}
        </span>
        {!isFromMapsApp && (
          <span className={styles.btn_wrapper}>
            <Clickable href={links.ALL_SERVICES} className={styles.btn}>
              전체서비스
            </Clickable>
          </span>
        )}
      </div>
      <div className={styles.sub_btn_area}>
        <span className={styles.btn_wrapper}>
          <Clickable onClick={goToPolicy} nClickCode={nClicks.footer.TERMS} className={styles.btn}>
            이용정책
          </Clickable>
        </span>
        <span className={styles.btn_wrapper}>
          <Clickable href={links.CUSTOMER_SERVICE} nClickCode={nClicks.footer.CS} className={styles.btn}>
            MY플레이스 고객센터
          </Clickable>
        </span>
        {isFromMapsApp ? (
          <span className={styles.btn_wrapper}>
            <Clickable href={links.MAP_CUSTOMER_SERVICE} className={styles.btn}>
              지도 고객센터
            </Clickable>
          </span>
        ) : (
          <span className={styles.btn_wrapper}>
            <Clickable href={links.SERVICE_NOTICE} nClickCode={nClicks.footer.NOTICE} className={styles.btn}>
              공지사항
            </Clickable>
          </span>
        )}
      </div>
      <div className={styles.copyright_area}>
        <Clickable href={links.NAVER_CORP} nClickCode={nClicks.footer.NAVER} className={styles.btn}>
          &copy; NAVER Corp.
        </Clickable>
      </div>
    </footer>
  )
}

export default Footer
